<template>
  <div class="button-options-data-dialog" :key="ids.elementInLayoutId">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item
        v-if="showSource"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="数据源"
        name="1"
      >
        <div class="data-source-type">
          <cx-slider :value.sync="notLocal" :options="dataOptions" :height="32" />
        </div>
        <div v-show="pageType !== 'detailPage' && pageType !== 'listPage' && noCacheComponent && !noCacheComponentLayout" class="mt12">
          <data-center-choose
            :checkStatus="checkStatus"
            :myId="ids"
            :options="options"
            @onDataCenterChange="onDataCenterChange"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="!notLocal"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
        title="文字内容"
        name="2"
      >
        <div class="setting-item" v-if="!isCollectButton && !isLikeButton">
          <div class="content">
            <div class="content-item verticallyCenter">
              <div
                class="edit-div"
                contenteditable="true"
                v-html="content"
                @blur="blurFunc($event)"
                @focus="focusFunc"
              ></div>
            </div>
          </div>
        </div>
        <template v-if="isCollectButton || isLikeButton">
          <div class="setting-item">
            <div class="content-item verticallyCenter">
              <span class="mr12" v-if="isCollectButton">收藏前</span>
              <span class="mr12" v-if="isLikeButton">点赞前</span>
              <div
                class="edit-div width-72"
                contenteditable="true"
                v-html="content"
                @blur="blurFunc($event, 1)"
                @focus="focusFunc"
              ></div>
            </div>
          </div>
          <div class="setting-item mt12">
            <div class="content-item verticallyCenter">
              <span class="mr12" v-if="isCollectButton">收藏后</span>
              <span class="mr12" v-if="isLikeButton">点赞后</span>
              <div
                class="edit-div width-72"
                contenteditable="true"
                v-html="contentActive"
                @blur="blurFunc($event, 2)"
                @focus="focusFunc"
              ></div>
            </div>
          </div>
        </template>
      </el-collapse-item>
      <el-collapse-item
        v-if="notLocal && showSource && (pageType === 'detailPage' || pageType === 'listPage' || showColsFieldMapping)"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
        title="数据绑定"
        name="3"
      >
        <div class="content">
          <colsFieldMappingSetting v-if="showColsFieldMapping && !multiImageDetail" :ids="dataIds" :myId="ids" :options="options"></colsFieldMappingSetting>
          <listPageFieldMappingSetting v-else-if="pageType === 'listPage'" :myid="ids" :options="options"></listPageFieldMappingSetting>
          <multiImageFieldMappingSetting v-else-if="multiImageDetail" :myid="ids" :options="options"></multiImageFieldMappingSetting>
          <detailPageFieldMappingSetting v-else :myid="ids" :options="options"></detailPageFieldMappingSetting>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-else-if="showSource && !noCacheComponentLayout && noCacheComponent"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
        title="数据绑定"
        name="3"
      >
        <div :class="currentFieldMappingFieldFlag ? 'mapping_content checked' : 'mapping_content'">
          <div class="verticallyBetweenCenter">
            <div class="content-title">
              {{ getValueByTypeHandle(options.innerElement) }}
            </div>
          </div>
          <div class="select_content mt8">
            <el-select
              style="width: 100%"
              v-model="currentFieldMappingFieldFlag"
              placeholder="请选择"
              clearable
            >
              <el-option v-for="(item, index) in currentFieldMappingList" :key="index" :label="item.label" :value="item.value">
                <span style="font-size: 13px">{{ item.label }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="verticallyCenter mapping_date_content mt8">
            <label class="date-label">显示为:</label>
            <el-dropdown trigger="click" @command="onChangeMappingType">
              <span class="el-dropdown-link">
                {{ fieldMappingDataTypeName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" :class="request_prefix === 'bigScreen' ? 'bigScreen custom-dropdown' : 'custom-dropdown'">
                <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
                  <div :class="fieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                    {{ item.label }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
        title="链接地址"
        name="4"
        v-if="linkAddrSet"
      >
        <div class="setting-item" v-if="isLoginType">
          <div class="content-item mb16 clearFloat">
            <el-checkbox-group v-model="openBlankPage">
              <el-checkbox :label="true" class="mr16">新页面打开</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="setting-item" v-if="!isWxLink && !isLoginType">
          <div class="font14 mb8">链接地址</div>
          <linkSet
            :linkAddress.sync="linkAddress"
            :internalLinkName.sync="internalLinkName"
            :subLinkName.sync="subLinkName"
            :linkUrl.sync="linkUrl"
            :accessRulers.sync="accessRulers"
            :openBlankPage.sync="openBlankPage"
            :businessType.sync="businessType"
            :isYzDataCenter="isYzDataCenter"
            :isCustomLinkTo="!isMoreBtn"
          />
        </div>
        <div class="setting-item" v-if="isWxLink">
          <div class="mb8">appId</div>
          <el-input style="width: 100%" v-model="wxAppid" placeholder="请输入以wx_开始的appId"></el-input>
          <div class="mb8 mt16">userName</div>
          <el-input style="width: 100%" v-model="wxUsername" placeholder="请输入以gh_开始的id"></el-input>
          <div class="mb8 mt16">跳转地址</div>
          <el-input style="width: 100%" v-model="wxLink" placeholder="请输入小程序跳转地址路径"></el-input>
          <div class="mb8 mt16">
            <el-checkbox v-model="openWxParam">同步登录状态</el-checkbox>
            <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick('3')"></i>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
        title="高级设置"
        name="5"
        v-if="hightSet"
      >
        <!-- 屏蔽设置项 根据接口返回判断 -->
        <!-- <div class="">
          <el-checkbox v-model="openDialog">开启弹窗</el-checkbox>
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick('1')"></i>
        </div>
        <div class="mt12">
          <el-checkbox v-model="isRefresh">是否刷新数据</el-checkbox>
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick('2')"></i>
        </div> -->
        <!-- 添加我的常用 -->
        <div v-if="!isReturnButton">
          <el-checkbox v-model="addMyApp">添加常用应用</el-checkbox>
        </div>
        <div v-if="isReturnButton" class="setting-item clearFloat">
          <cx-check-box :value.sync="hideBackButton">新页面打开时隐藏“返回按钮”</cx-check-box>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
        title="整屏切换控制"
        name="6"
        v-if="isAdmin && globalEnableFullScroll && !isTop && !isReturnButton"
      >
        <div class="mb10">跳转方式:</div>
        <el-select v-model="pageFullScrollControlType" class="mb10" style="width: 100%">
          <el-option label="跳转上一屏" value="up"></el-option>
          <el-option label="跳转下一屏" value="down"></el-option>
          <el-option label="跳转指定屏" value="toAssignedPage"></el-option>
        </el-select>
        <div class="mb10" v-if="pageFullScrollControlType === 'toAssignedPage'">指定跳转屏:</div>
        <el-input
          :controls="false"
          type="number"
          v-if="pageFullScrollControlType === 'toAssignedPage'"
          v-model="pageFullScrollControlIndex"
          placeholder="请输入需要跳转的通栏顺序"
        >
        </el-input>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import detailPageFieldMappingSetting from "publicSetting/detailPageFieldMappingSetting.vue"
import listPageFieldMappingSetting from "publicSetting/listPageFieldMappingSetting.vue"
import multiImageFieldMappingSetting from "publicSetting/multiImageFieldMappingSetting.vue"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import { isExist, getValueByType, _debounce, simpleDeepClone } from "utils"
import { historyIgnoreWrap } from "utils/revork"
import dataToolMixin from "materials/dataToolMixin"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"

export default {
  name: "button-options-data",
  components: { colsFieldMappingSetting, detailPageFieldMappingSetting, listPageFieldMappingSetting, multiImageFieldMappingSetting, dataCenterChoose },
  mixins: [dataToolMixin],
  props: {
    options: Object,
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      collapseActiveNames: ["1", "2", "3", "4"],
      activeNames: ["1", "2", "3", "4"],
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      currentFieldMappingList: [],
      dataTypeList: [
        {
          label: "字段名称+字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
    }
  },
  computed: {
    isMoreButton() {
      // 判断是否是自由布局边栏的更多按钮
      if (typeof this.ids?.directionIndex === 'undefined') return false
      return this.businessType === "more"
    },
    showColsFieldMapping() {
      return this.dataIds?.uid || isExist(this.dataIds?.elementInSwiperId) || this.dataIds?.elementInDataGridId
    },
    isWxLink() {
      return this.options.isWxLink
    },
    globalEnableFullScroll() {
      return this.$store.state[this.request_prefix].page.enableFullScroll
    },
    isDrawer() {
      return this.options.pluginName?.includes("drawerPlugin") || false
    },
    pageFullScrollControlType: {
      get() {
        return this.options.pageFullScrollControlType || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageFullScrollControlType", false, undefined, this.originalIds)
      }
    },
    pageFullScrollControlIndex: {
      get() {
        return this.options.pageFullScrollControlIndex
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageFullScrollControlIndex", false, undefined, this.originalIds)
      }
    },
    wxAppid: {
      get() {
        return this.options.wxAppid
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "wxAppid", false, undefined, this.originalIds)
      }
    },
    wxUsername: {
      get() {
        return this.options.wxUsername
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "wxUsername", false, undefined, this.originalIds)
      }
    },
    wxLink: {
      get() {
        return this.options.wxLink
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "wxLink", false, undefined, this.originalIds)
      }
    },
    openWxParam: {
      get() {
        return this.options.openWxParam
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openWxParam", false, undefined, this.originalIds)
      }
    },
    isMoreBtn() {
      // 如果是更多按钮，则不能自定义子页面的打开方式
      if (this.businessType === "more") {
        return true
      }
      return false
    },
    isAdmin() {
      return this.$store.state.states.managerType === 1 ? true : false
    },
    isBigScreen() {
      if (this.request_prefix === "bigScreen") {
        return true
      } else {
        return false
      }
    },
    content: {
      get() {
        let content = `${this.options.content}`?.replace(/(<br>)*$/g, "") //替换末尾换行符
        return content
      },
      set(newVal) {
        newVal = String(newVal).replace(/<[^>]+>/g, "<br>")
        this.$changeOptionsEV(newVal, "content", false, undefined, this.originalIds)
      }
    },
    contentActive: {
      get() {
        let contentActive = this.options.contentActive?.replace(/(<br>)*$/g, "") //替换末尾换行符
        return contentActive
      },
      set(newVal) {
        newVal = String(newVal).replace(/<[^>]+>/g, "<br>")
        this.$changeOptionsEV(newVal, "contentActive", false, undefined, this.originalIds)
      }
    },
    openBlankPage: {
      get() {
        return this.options.openBlankPage
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openBlankPage", false)
      }
    },
    accessRulers: {
      get() {
        return this.options.accessRulers ? this.options.accessRulers : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "accessRulers", false)
      }
    },
    internalLinkName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "internalLinkName", "internalLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "internalLinkName", false)
      }
    },
    subLinkName: {
      get(val) {
        return this.checkAndSetPrimaryVal(this.options, "subLinkName", "subLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "subLinkName", false)
      }
    },
    isYzDataCenter() {
      if (this.businessType !== 'more') return false
      return this.parentAttrs?.useYzDataCenter
    },
    isInAutoLayout() {
      return isExist(this.ids.elementInAutoLayoutId)
    },
    parentAttrs() {
      let ids = simpleDeepClone(this.ids)
      if (this.isInAutoLayout) {
        delete ids.elementInLayoutId
        delete ids.directionIndex
      }
      const rectAttr = this.isInAutoLayout ? this.getAttrById(
        this.$store.state[this.request_prefix],
        ids
      ) : this.getAttrById(
        this.$store.state[this.request_prefix],
        {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        "rect"
      )?.options
      return rectAttr
    },
    businessType() {
      // 原有的取法有问题，如果是在自动布局里面，这样子就取到自动布局本身了，但是本意是想取图文列表的样式

      const businessType = this.parentAttrs?.titleOptions?.[this.ids.directionIndex]?.elementOptions.find(
        it => it.elementInLayoutId === this.ids.elementInLayoutId
      ).type
      return businessType
    },
    linkAddress: {
      get() {
        if (this.businessType === "more" && !this.options.linkAddress) {
          historyIgnoreWrap(() => {
            this.linkAddress = "默认"
          })()
        }
        return this.options.linkAddress
      },
      set(newVal) {
        if (this.businessType === "more" && !newVal) {
          return
        }
        this.$changeOptionsEV(newVal, "linkAddress", false)
      }
    },
    linkUrl: {
      get() {
        if (this.options.linkUrl !== "") {
          historyIgnoreWrap(() => {
            this.linkAddress = this.linkAddress ? this.linkAddress : this.internalLinkName ? "内部链接" : "自定义"
          })()
        }
        return this.options.linkUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkUrl", false)
        if (this.businessType === "more") {
          // 如果是自由布局的更多按钮, 并且该自由布局的数据源为云舟数据源时，同步云舟数据源的moreUrl地址
          this.updateMoreUrl(newVal)
        }
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    openDialog: {
      get() {
        return this.options.hasOwnProperty("openDialog") ? this.options.openDialog : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openDialog", false)
      }
    },
    isRefresh: {
      get() {
        return this.options.hasOwnProperty("isRefresh") ? this.options.isRefresh : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isRefresh", false)
      }
    },
    isLoginType() {
      return this.options.loginType
    },
    isSearchType() {
      return this.options.searchType
    },
    isLoginLayout() {
      if (
        this.layoutOptions?.pluginName &&
        (this.layoutOptions?.pluginName.includes("loginLayoutComponent") ||
          this.layoutOptions?.pluginName.includes("searchComponentPlugin"))
      ) {
        return true
      } else {
        return false
      }
    },
    isCollectButton() {
      return this.options && this.options.pluginName && this.options.pluginName.includes("collectPlugin")
    },
    isLikeButton() {
      return this.options && this.options.pluginName && this.options.pluginName.includes("likePlugin")
    },
    // 返回按钮
    isReturnButton() {
      return this.options && this.options.pluginName && this.options.pluginName.includes("returnPlugin")
    },
    needLinkSetComponent() {
      if (this.hasFiledMapping) {
        return false
      }
      if (this.isLoginType) return false // 登录框、搜索业务组件
      if (this.layoutOptions && this.layoutOptions.componentTypeName === "cxSystemSearch") {
        if (this.options.searchType) {
          return false
        }
        return true
      } else if (this.layoutOptions?.pluginName && this.layoutOptions?.pluginName[0] === "loginLayoutComponent") {
        return true
      } else if (this.layoutOptions?.pluginName && this.layoutOptions?.pluginName[0] === "loginEngineComponentPlugin") {
        return true
      } else if (this.layoutOptions?.menuName === "超星头像") {
        return true
      } else {
        return false
      }
    },
    hasFiledMapping() {
      // 判断当前文本是否绑定了外接数据源
      if (this.options.filedMapping && this.options.filedMapping.value) {
        return true
      }
      return false
    },
    // 判断是否是在登录框内
    isLoginEngineComponent() {
      if (this.layoutOptions?.pluginName && this.layoutOptions?.pluginName[0] === "loginEngineComponentPlugin") {
        return true
      } else {
        return false
      }
    },
    hasGetDetailDataPlugin() {
      return this.layoutOptions?.pluginName?.includes("getDetailDataPlugin")
    },
    dataOptions() {
      const options = [{ value: false, title: "本地数据" }]
      if (this.pageType === "detailPage" || this.pageType === "listPage" || this.showColsFieldMapping) {
        options.push({ value: true, title: "数据绑定" })
      } else if((this.isBigScreen && !this.noCacheComponentLayout) || (!this.isBigScreen && !this.showColsFieldMapping)) {
        options.push({ value: true, title: "数据中心" })
      }
      return options
    },
    notLocal: {
      get() {
        if (this.noCacheComponentLayout) {
          return !!this.options.filedMapping?.value
        } else {
          return this.noCacheComponent
        }
      },
      set(newVal) {
        if (this.noCacheComponentLayout) {
          if (!this.options.filedMapping) {
            this.$changeOptionsEV({}, "filedMapping", false, false, false, true)
          }
          this.$changeOptionsEV(newVal ? "0" : "", "filedMapping.value", false)
        } else {
          this.noCacheComponent = newVal
        }
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
        // 如果在详情页中文本组件选中外接数据源，需要先初始化文本组件在详情页的相关对象属性detailFieldMapping，同时给文本组件增加在详情页中请求数据源的插件
        // 切换到本都数据的时候，清除之前绑定的appId
        if (!newVal) {
          this.$changeOptionsEV("", "appId", false, false, false, true)
        }
        if ((this.pageType === "detailPage" || this.pageType === "listPage") && newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataKey",
              fieldFlag: ""
            },
            "detailFieldMapping",
            false,
            false,
            false,
            true
          )
        }
        if (this.pageType !== "detailPage" && this.pageType !== "listPage" && newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataValue",
              fieldFlag: ""
            },
            "currentFiledMapping",
            false,
            false,
            false,
            true
          )
        }
      }
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    showSource() {
      return !this.isLoginLayout && !this.isCollectButton && !this.isLikeButton && !this.isLoginType && !this.isReturnButton
    },
    addMyApp: {
      get() {
        return this.options.hasOwnProperty("addMyApp") ? this.options.addMyApp : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "addMyApp", false)
      }
    },
    isTop() {
      return this.options.pluginName?.includes("goTopPlugin")
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.dataIds)
    },
    currentFiledMapping: {
      get() {
        return this.options.currentFiledMapping
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping", false)
      }
    },
    currentFiledMappingChecked: {
      get() {
        return this.options.currentFiledMapping?.isChecked || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.isChecked", false)
      }
    },
    currentFieldMappingFieldFlag: {
      get() {
        return this.options.currentFiledMapping?.fieldFlag
      },
      set(newVal) {
        if(!this.currentFiledMappingChecked) {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
          this.$changeOptionsEV(true, "currentFiledMapping.isChecked", false, false, false, true)
        } else {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
        }
      }
    },
    fieldMappingDataType: {
      get() {
        return this.currentFiledMapping?.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.dataType", false, null, {
          ...this.ids
        })
      }
    },
    fieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.fieldMappingDataType)
      return item?.label || ""
    },
    hideBackButton: {
      get() {
        return this.options.hideBackButton || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hideBackButton", false)
      }
    },
    //链接地址
    linkAddrSet() {
      let showSet = false
      if(!this.isBigScreen && !this.showColsFieldMapping && !this.isDrawer && !this.isCollectButton && !this.isLikeButton && !this.isTop && !this.isReturnButton){
        showSet = true
      }else if(this.isBigScreen && !this.isReturnButton){
        showSet = true
      }else if(this.isWxLink){
        showSet = true
      }else if(this.needLinkSetComponent){
        showSet = true
      }
      return showSet
    },
    //高级设置
    hightSet() {
      let showSet = false
      if(this.isAdmin && !this.isWxLink && !this.isDrawer && !this.isCollectButton && !this.isLikeButton &&
          !this.isTop && !this.isSearchType && !this.isLoginType && !this.multiImageDetail ){
        showSet = true
      }else if(this.isBigScreen && this.isReturnButton){
        showSet = true
      }
      return showSet
    }
  },
  watch: {
    currentFiledMapping: {
      deep: true,
      handler(n, o) {
        if (n && n.isChecked) {
          if (this.currentFieldMappingList.length > 0) {
            this.currentFieldMappingList.forEach((item) => {
              if (item.value === n.fieldFlag) {
                switch (n.dataType) {
                  case "dataKey":
                    this.content = item.label + "：" + item.content
                    break
                  case "dataValue":
                    this.content = item.content
                    break
                  case "dataName":
                    this.content = item.label
                    break
                }
              }
            })
          }
        }
      }
    }
  },
  mounted() {
    this.originalIds = JSON.parse(JSON.stringify(this.$store.state.states.activeID))
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  updated() {
    this.originalIds = JSON.parse(JSON.stringify(this.$store.state.states.activeID))
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  methods: {
    updateMoreUrl: _debounce(function (url) {
      const rectAttr = this.parentAttrs
      // 有数据源名字，目前判断不出该数据源是否是云舟数据源，直接都写
      if (rectAttr?.dataCenterName && rectAttr?.publicId && rectAttr?.useYzDataCenter) {
        // TODO 调用接口去改数据源中的moreUrl值
        this.$API.updateAppAttr({
          param:  {
            publicId: rectAttr?.publicId,
            moreUrl: encodeURIComponent(url)
          }
        })
      }
    }, 1000),
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "1":
          this.explainTitle = "开启说明文字"
          this.explainTips = "点击按钮后出现弹窗，并在弹窗内显示数据源传递过来的提示语"
          break
        case "2":
          this.explainTitle = "刷新页面数据说明文字"
          this.explainTips = "在弹窗中点击确认后，刷新页面并更新页面显示内容"
          break
        case "3":
          this.explainTitle = "同步登录状态"
          this.explainTips = "点击开启同步登录状态，则会同步当前用户登录信息至小程序端"
      }
    },
    blurFunc($event, type) {
      if (type === 2) {
        this.contentActive = $event.target.innerHTML
      } else {
        this.content = $event.target.innerHTML
      }
      sessionStorage.removeItem("isInputFocus")
    },
    focusFunc() {
      sessionStorage.setItem("isInputFocus", true)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(this, datas => {
          if (typeof datas === "string") {
            return
          }
          if (
            !this.options.currentFiledMapping ||
            (this.options.currentFiledMapping && !this.options.currentFiledMapping.isChecked)
          ) {
            if (datas.length === 0) {
              this.content = ""
            } else {
              this.content = datas[0][Object.keys(datas[0])[0]].value
            }
          } else if (this.options.currentFiledMapping && this.options.currentFiledMapping.fieldFlag) {
            const dataType = this.options.currentFiledMapping.dataType
            const data = datas[0][this.options.currentFiledMapping.fieldFlag]
            let tempDataValue = data.value
            if (dataType === "dataKey") {
              tempDataValue = data.key + "：" + data.value
            } else if (dataType === "dataName") {
              tempDataValue = data.key
            }
            this.content = tempDataValue
          }
          // type: 是否要重新加入字段匹配下拉项 避免点击数据响应就加一次
          if (datas) {
            const list = []
            Object.keys(datas[0]).forEach((key) => {
              if (key === "content") return
              if (key && datas[0][key]?.value) {
                const temp = {
                  value: key,
                  label: datas[0][key].key,
                  content: datas[0][key].value
                }
                list.push(temp)
              }
            })
            this.currentFieldMappingList = list
          }
        })
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    onChangeMappingType(value) {
      this.fieldMappingDataType = value
    },
    onDataCenterChange() {
      if(!this.noCacheComponentLayout && this.noCacheComponent) {
        this.getBaseModuleDataLoop()
      }
    },
    updateToolbarData() {
      if(!this.noCacheComponentLayout && this.noCacheComponent) {
        this.getBaseModuleDataLoop()
      }
    },
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
  }
}
</script>

<style lang="scss" scoped>
.no-break {
  word-break: keep-all;
}
.text-inp {
  max-width: 236px;
  width: calc(100% - 50px);
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px;
}
.edit-div:focus {
  outline: none;
  border: 1px solid var(--themeColor);
}
.edit-div.width-72 {
  width: calc(100% - 72px);
}
.tips-btn {
  margin-top: 3px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
}
</style>
